"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.FullSizeError = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/json/stringify"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _FullSizeError = require("../FullsizeError/FullSizeError.styles");

var _SaveStringButton = require("../SaveStringButton/SaveStringButton");

var _ErrorDetailComponent = require("./ErrorDetailComponent");

var getClassNames = (0, _react.classNamesFunction)();
var loadingErrorImage = '/images/loadingError.svg';
var saveErrorFileName = 'ErrorDetails.txt';

var FullSizeError = function FullSizeError(_ref) {
  var actionButtonProps = _ref.actionButtonProps,
      message = _ref.message,
      correlationId = _ref.correlationId,
      errorCode = _ref.errorCode,
      subtitle = _ref.subtitle,
      errorTitle = _ref.errorTitle,
      sessionId = _ref.sessionId,
      userId = _ref.userId,
      _ref$labels = _ref.labels,
      timeLabel = _ref$labels.timeLabel,
      errorCodeLabel = _ref$labels.errorCodeLabel,
      correlationIdLabel = _ref$labels.correlationIdLabel,
      sessionIdLabel = _ref$labels.sessionIdLabel,
      userIdLabel = _ref$labels.userIdLabel,
      detailsLabel = _ref$labels.detailsLabel,
      unknownErrorTitle = _ref$labels.unknownErrorTitle,
      viewMoreLabel = _ref$labels.viewMoreLabel,
      viewLessLabel = _ref$labels.viewLessLabel,
      defaultErrorButtonActionLabel = _ref$labels.defaultErrorButtonActionLabel;

  var _useState = (0, React.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var time = (0, React.useMemo)(function () {
    return new Date().toLocaleString();
  }, []);
  var toggleCollapsedState = (0, React.useCallback)(function () {
    var newState = !isExpanded;
    setIsExpanded(newState);
  }, [isExpanded]);

  var getErrorData = function getErrorData() {
    var errorObject = {
      title: errorTitle,
      subtitle: subtitle,
      message: message,
      correlationId: correlationId,
      errorCode: errorCode,
      sessionId: sessionId,
      userId: userId
    };
    return (0, _stringify.default)(errorObject, null, 4);
  };

  var classes = getClassNames(_FullSizeError.styles);
  var titleText = errorTitle || unknownErrorTitle;
  var toggleCollapseControlText = isExpanded ? viewLessLabel : viewMoreLabel;
  var actionButtonLabel = actionButtonProps && actionButtonProps.actionLabel || defaultErrorButtonActionLabel;
  var errorCodeIsUnauthorizedOrForbidden = "".concat(errorCode) === '403' || "".concat(errorCode) === '401';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    role: "alert",
    "aria-labelledby": "ms-banner",
    className: classes.root,
    dir: "ltr",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _react.css)(classes.rootContent, 'ms-Grid'),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _react.css)(classes.imageContainer, 'ms-Grid-row', 'ms-sm12', 'ms-md6', 'ms-lg4'),
        children: errorCodeIsUnauthorizedOrForbidden ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
          iconName: "Blocked"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: loadingErrorImage,
          "aria-hidden": true
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _react.css)(classes.errorDetailsContainer, 'ms-Grid-row', 'ms-sm12'),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: (0, _react.css)(classes.errorDetails, 'ms-Grid-row', 'ms-sm10', 'ms-md5'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: (0, _react.css)(classes.titleText),
            children: titleText
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: (0, _react.css)(classes.friendlyPromptText),
            children: subtitle
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Stack, {
            horizontal: true,
            horizontalAlign: 'space-around',
            className: (0, _react.css)(classes.toggleControls, 'ms-sm10'),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Link, {
              onClick: toggleCollapsedState,
              children: toggleCollapseControlText
            }), actionButtonProps && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.PrimaryButton, {
              text: actionButtonLabel,
              allowDisabledFocus: true,
              disabled: false,
              onClick: actionButtonProps.onActionPressed
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: classes.expandedView,
            children: isExpanded && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Stack, {
              wrap: true,
              horizontal: true,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SaveStringButton.SaveStringButton, {
                stringToSave: getErrorData(),
                fileName: saveErrorFileName,
                buttonProps: {
                  className: classes.downloadButton
                }
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorDetailComponent.ErrorDetailComponent, {
                label: timeLabel,
                value: time
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorDetailComponent.ErrorDetailComponent, {
                label: sessionIdLabel,
                value: sessionId
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorDetailComponent.ErrorDetailComponent, {
                label: correlationIdLabel,
                value: correlationId
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorDetailComponent.ErrorDetailComponent, {
                label: errorCodeLabel,
                value: errorCode
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorDetailComponent.ErrorDetailComponent, {
                label: userIdLabel,
                value: userId
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorDetailComponent.ErrorDetailComponent, {
                label: detailsLabel,
                value: message,
                isFullWidth: true
              })]
            })
          })]
        })
      })]
    })
  });
};

exports.FullSizeError = FullSizeError;